export const MaintenanceStatus = {
  LOADING: 'loading',
  MAINTENANCE: 'maintenance',
  OPERATIONAL: 'operational',
} as const;

export type Status = (typeof MaintenanceStatus)[keyof typeof MaintenanceStatus];
